// removed by extract-text-webpack-plugin
module.exports = {"circleBlue":"_223BRq1ttH_JkWCnblR77C","circleOrange":"_35Rugzx7lH2uDLm4i22QIN","colorBlack":"_3J1rEdr6tHWsxwTVdDwlD-","circleRed":"CP62CKLJzBnEKOO4ht507"};


//////////////////
// WEBPACK FOOTER
// ./components/Notification/style.css
// module id = 1211
// module chunks = 0